/** First human-readable message from a DRF error body (``detail`` or field lists). */
export function messageFromDrfError(err: unknown, fallback: string): string {
  const data = (err as { response?: { data?: unknown } })?.response?.data;
  if (data == null || typeof data !== "object") return fallback;
  const d = data as Record<string, unknown>;
  if (typeof d.detail === "string") return d.detail;
  if (Array.isArray(d.detail)) return d.detail.map(String).join(" ");
  const parts: string[] = [];
  for (const v of Object.values(d)) {
    if (Array.isArray(v)) parts.push(v.map(String).join(" "));
    else if (typeof v === "string") parts.push(v);
  }
  return parts.length > 0 ? parts.join(" ") : fallback;
}
